import type { SiteEvent } from '../api/public'

/** Prefer CMS-flagged promoted upcoming; else soonest by `startsAt`. */
export function pickPromotedUpcoming(events: SiteEvent[] | undefined): SiteEvent | null {
  if (!events?.length) return null
  const upcoming = events.filter((e) => e.displayStatus === 'upcoming')
  if (!upcoming.length) return null
  const promoted = upcoming.find((e) => e.promotedOnEventsPage === true)
  if (promoted) return promoted
  return [...upcoming].sort((a, b) => new Date(a.startsAt).getTime() - new Date(b.startsAt).getTime())[0]!
}
